/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_POS_REVENUE_AND_FUEL_STATS = gql`
  query GetPosRevenueAndFuelStats(
    $filters: PosRevenueAndFuelFilter!
    $order: PosRevenueAndFuelOrdering
    $pagination: OffsetLimitPaginationFilter
  ) {
    posRevenueAndFuelStats(
      filters: $filters
      order: $order
      pagination: $pagination
    ) {
      totalCount
      results {
        name
        storeId
        totalRevenue
        previousTotalRevenue
        insideSales
        previousInsideSales
        outsideSales
        previousOutsideSales
        fuelVolume
        previousFuelVolume
      }
    }
  }
`
